import React, { useEffect, useMemo } from 'react'
import OptionSelector from '../shared/OptionSelector'
import WindowDiagram from '../diagrams/WindowDiagram'

const GridOptionsTab = ({
  formData,
  onChange,
  availableOptions,
  windowProduct
}) => {
  const isBayWindow = windowProduct.name === 'Bay'
  const gridLocationField = isBayWindow ? 'end_lite_grid_location_id' : 'grid_location_id'
  const gridStyleField = 'grid_style_id'
  const allGridLocations = isBayWindow ? availableOptions.end_lite_grid_locations : availableOptions.grid_locations
  const gridStyles = availableOptions.grid_styles

  // Get selected end lite style for bay windows
  const selectedEndLiteStyle = useMemo(() => {
    if (!isBayWindow || !formData.end_lite_style_id) return null
    return availableOptions.end_lite_styles?.find(
      style => style.id === formData.end_lite_style_id
    )
  }, [isBayWindow, formData.end_lite_style_id, availableOptions.end_lite_styles])

  // Filter grid locations based on selected style for bay windows
  const gridLocations = useMemo(() => {
    if (!isBayWindow || !selectedEndLiteStyle) return allGridLocations

    const styleName = selectedEndLiteStyle.name.toLowerCase()

    const filterByKeywords = (keywords) => {
      return allGridLocations?.filter(loc => {
        const name = loc.name.toLowerCase()
        return keywords.some(keyword => name.includes(keyword))
      })
    }

    if (styleName === 'double hung') {
      return filterByKeywords(['top sash', 'bottom sash', 'both sash'])
    }

    if (styleName === 'casement') {
      return filterByKeywords(['full'])
    }

    return allGridLocations
  }, [isBayWindow, selectedEndLiteStyle, allGridLocations])

  // Clear grid location if it's incompatible with the selected style
  useEffect(() => {
    if (!isBayWindow || !formData[gridLocationField] || !formData.end_lite_style_id) return

    const isLocationAvailable = gridLocations?.some(loc => loc.id === formData[gridLocationField])

    if (!isLocationAvailable) {
      onChange(gridLocationField, null)
    }
  }, [isBayWindow, formData.end_lite_style_id, formData[gridLocationField], gridLocations, gridLocationField, onChange])

  return (
    <div className="flex flex-col items-center py-4">
      <div className="relative">
        <WindowDiagram
          windowTypeName={windowProduct.name}
          selectedValue={formData[gridLocationField]}
          availableOptions={gridLocations}
          onChange={(value) => onChange(gridLocationField, value)}
          mode="grid"
          disabled={isBayWindow ? !formData.end_lite_style_id : !formData[gridStyleField]}
          formData={formData}
          allAvailableOptions={availableOptions}
        />
        <div className="flex justify-center md:block md:absolute md:left-full md:ml-4 md:top-1/2 md:transform md:-translate-y-1/2 md:whitespace-nowrap mt-4 md:mt-0">
          <OptionSelector
            name={gridStyleField}
            options={gridStyles}
            value={formData[gridStyleField]}
            onChange={(value) => onChange(gridStyleField, value)}
            radio={true}
            includeNone={false}
            optionTestIdPrefix="grid-style"
          />
        </div>
      </div>
    </div>
  )
}

export default GridOptionsTab
